export const GET_EVALUATION_TYPES = "GET_EVALUATION_TYPES"
export const GET_EVALUATION_TYPES_FAIL = "GET_EVALUATION_TYPES_FAIL"
export const GET_EVALUATION_TYPES_SUCCESS = "GET_EVALUATION_TYPES_SUCCESS"

export const ADD_NEW_EVALUATION_TYPE = "ADD_NEW_EVALUATION_TYPE"
export const ADD_EVALUATION_TYPE_SUCCESS = "ADD_EVALUATION_TYPE_SUCCESS"
export const ADD_EVALUATION_TYPE_FAIL = "ADD_EVALUATION_TYPE_FAIL"

export const UPDATE_EVALUATION_TYPE = "UPDATE_EVALUATION_TYPE"
export const UPDATE_EVALUATION_TYPE_SUCCESS = "UPDATE_EVALUATION_TYPE_SUCCESS"
export const UPDATE_EVALUATION_TYPE_FAIL = "UPDATE_EVALUATION_TYPE_FAIL"

export const DELETE_EVALUATION_TYPE = "DELETE_EVALUATION_TYPE"
export const DELETE_EVALUATION_TYPE_SUCCESS = "DELETE_EVALUATION_TYPE_SUCCESS"
export const DELETE_EVALUATION_TYPE_FAIL = "DELETE_EVALUATION_TYPE_FAIL"




